import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
const SECTIONS = [{
  title: 'Introduction',
  body: 'Maisha Medical Center ("we", "us", "our") is committed to protecting the privacy and confidentiality of our patients and website visitors. This Privacy Policy explains how we collect, use, store, and safeguard your personal and health information when you use our services or interact with our website.'
}, {
  title: 'Information We Collect',
  body: 'We may collect personal information such as your name, contact details, date of birth, national identification, and medical history. This information is collected when you book an appointment, complete forms, contact us, or receive treatment at our facility.'
}, {
  title: 'How We Use Your Information',
  body: 'Your information is used to provide and improve healthcare services, schedule and confirm appointments, maintain accurate medical records, process medical aid claims, and communicate important updates regarding your care. We do not sell your personal information to third parties.'
}, {
  title: 'Confidentiality of Medical Records',
  body: 'All patient records are handled with the strictest confidentiality and are only accessible to authorized medical personnel directly involved in your care. We comply with applicable healthcare and data protection regulations in Botswana.'
}, {
  title: 'Data Security',
  body: 'We implement appropriate technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction. Access to sensitive data is restricted to authorized staff only.'
}, {
  title: 'Sharing of Information',
  body: 'We may share your information with medical aid providers for claims processing, referral specialists or laboratories involved in your care, and regulatory authorities where required by law. Any such sharing is done in accordance with confidentiality obligations.'
}, {
  title: 'Your Rights',
  body: 'You have the right to access your personal information, request corrections to inaccurate data, and ask questions about how your information is handled. To exercise these rights, please contact our reception desk.'
}, {
  title: 'Contact Us',
  body: 'If you have any questions about this Privacy Policy or how your information is handled, please contact us at bookings@maishahealth.co.bw or call +267 6540244.'
}];
export function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-brand-light pb-20" data-id="element-786" data-mp="1egqxwp4118g0">
      <div className="bg-brand-navy py-20 relative overflow-hidden" data-id="element-787" data-mp="1eibtmi22uxfg">
        <div className="absolute -top-[30%] -right-[10%] w-[60%] h-[140%] rounded-full bg-brand-red/5 blur-[120px] pointer-events-none" data-id="element-788" data-mp="1affifceva3lj" />
        <div className="max-w-brand mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-789" data-mp="1jflrmm3j8hew">
          <nav aria-label="Breadcrumb" className="flex items-center justify-center gap-2 text-sm text-slate-300 mb-6" data-id="element-790" data-mp="1jdr6b6ocmnaa">
            <Link to="/" className="hover:text-brand-gold transition-colors" data-id="element-791" data-mp="27z5mwz2oagvv">
              Home
            </Link>
            <ChevronRight className="w-4 h-4" data-id="element-792" data-mp="1t2of2htozke2" />
            <span className="text-brand-gold" data-id="element-793" data-mp="1y20ystp9obcf">Privacy Policy</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-794" data-mp="1kaw5sagemhb2">
            Privacy Policy
          </h1>
          <p className="text-slate-300" data-id="element-795" data-mp="1p1uo1fkydpgy">Last updated: June 2026</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-796" data-mp="1ad89vh72b3rb">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 md:p-12 space-y-10" data-id="element-797" data-mp="1aavk4hv2bp3p">
          {SECTIONS.map(section => <section key={section.title} data-id="element-798" data-mp="11d32h71vc5d5">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-brand-navy mb-3" data-id="element-799" data-mp="11e4p88s8ygap">
                {section.title}
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-800" data-mp="yaosj9brbq00">{section.body}</p>
            </section>)}
        </div>
      </div>
    </div>;
}